var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('card-m',{attrs:{"title":"设计任务分配情况","cardWidth":"100%","cardHeight":"90%"}},[_c('template',{slot:"card-box"},[_c('cardTable',{attrs:{"total":_vm.totalCounts,"tableColumn":_vm.column,"tableData":_vm.tableData,"loading":_vm.loading,"showPaging":false}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }